module.exports = __webpack_public_path__ + "img/Avatar.c74b09c3.svg";